var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#353A40",
  d: "M12 2.667h-1.393a.7.7 0 0 1-.474-.193h.007L9.867 2.2a.67.67 0 0 0-.474-.193h-2.78a.7.7 0 0 0-.473.193l-.273.274a.67.67 0 0 1-.474.193H4c-.367 0-.667.3-.667.667 0 .366.3.666.667.666h8c.367 0 .667-.3.667-.666s-.3-.667-.667-.667m-8 10C4 13.4 4.6 14 5.333 14h5.334C11.4 14 12 13.4 12 12.667v-8H4zM9.333 6.34a.33.33 0 0 1 .334-.333.33.33 0 0 1 .333.333v6a.33.33 0 0 1-.333.334.33.33 0 0 1-.334-.334zM6 6.34a.33.33 0 0 1 .333-.333.33.33 0 0 1 .334.333v6a.33.33 0 0 1-.334.334A.33.33 0 0 1 6 12.34z"
})));
export { SvgDelete as ReactComponent };